export const SET_BIG_NUMBERS = 'SET_BIG_NUMBERS';
export const setBigNumbers = (payload) => ({
  type: SET_BIG_NUMBERS,
  payload,
});
